import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaYoutube, FaCopy } from 'react-icons/fa';
import { QRCodeSVG } from 'qrcode.react';
import Web3 from 'web3';
import { decryptCode } from '../Components/Decrypt';


function Wallet() {
    const queryParams = new URLSearchParams(useLocation().search);
    const walletId = queryParams.get("walletId");
    const authToken = sessionStorage.getItem('authToken');
    const baseurl = process.env.REACT_APP_BASE_API_URL;
    const [walletData, setWalletData] = useState([]);
    const [tabelLoading, setTableLoading] = useState(false)
    const [adminUsdtBalance, setAdminUsdtBalance] = useState('0')
    const [adminBnbBalance, setAdminBnbBalance] = useState('0')
    const [masterData, setMasterData] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [balance, setBalance] = useState(null);
    const [bnbBalance, setBnbBalance] = useState(null);
    const [transaction, setTransactions] = useState([]);
    const BSC_RPC = 'https://bsc-dataseed.binance.org/';
    const web3 = new Web3(BSC_RPC);
    const USDT_ADDRESS = '0x55d398326f99059fF775485246999027B3197955';

    const USDT_ABI = [{ "inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "constant": true, "inputs": [], "name": "_decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "burn", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "subtractedValue", "type": "uint256" }], "name": "decreaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "getOwner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "addedValue", "type": "uint256" }], "name": "increaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "mint", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "renounceOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }];

    useEffect(() => {
        const fetchProfileData = async () => {
            if (!walletId) {
                toast.error("No Wallet ID provided in URL.");
                return;
            }

            setLoading(true);

            try {
                const response = await axios.post(
                    `${baseurl}/wallet-details`,
                    { wallet_address: walletId },
                    {
                        headers: {
                            Authorization: `Bearer ${authToken}`,
                        },
                    }
                );

                const data = response.data;

                if (!data.status) {
                    toast.error(data.message || "Something went wrong!");
                }

                setWalletData(data.data ?? null);
                setMasterData(data.setting ?? null)

               

                await loadBalance(data.data.address);

                await fetchTransactions(USDT_ADDRESS, data.data.address, data.setting.bsc_key)

                console.log('Wallet Data', data.data)
            } catch (error) {
                toast.error("Error fetching user details.");
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchProfileData();
    }, [walletId, authToken, baseurl]);

    const handleProfileDataFetched = (data) => {
        // Optional: Handle Auth result
    };



    // 👉 Function to get USDT balance of a wallet address from BSC
    const loadBalance = async (walletAddress) => {

        console.log('Wallet Adrress', walletAddress)
        try {
            const web3 = new Web3(new Web3.providers.HttpProvider(BSC_RPC));
            const contract = new web3.eth.Contract(USDT_ABI, USDT_ADDRESS);

            const rawBalance = await contract.methods.balanceOf(walletAddress).call();

            // Optional: verify decimals if unsure
            const decimals = await contract.methods.decimals().call(); // should return 18

            // Convert from wei (18 decimals) to readable number
            const formattedBalance = web3.utils.fromWei(rawBalance, 'ether');

            setBalance(formattedBalance)

            // 2. Get BNB Balance
            const rawBNBBalance = await web3.eth.getBalance(walletAddress);
            const formattedBNBBalance = web3.utils.fromWei(rawBNBBalance, 'ether');
            setBnbBalance(formattedBNBBalance);

        } catch (error) {
            console.error('Error fetching USDT balance:', error);
            return null;
        }
    };


    const fetchTransactions = async (usdtAddress, walletAddress, API_KEY) => {
        try {
            const url = `https://api.bscscan.com/api?module=account&action=tokentx&contractaddress=${usdtAddress}&address=${walletAddress}&page=1&offset=20&startblock=0&endblock=99999999&sort=desc&apikey=${API_KEY}`;
            const response = await axios.get(url);

            if (response.data.status === '1') {
                setTransactions(response.data.result);
                setTableLoading(true)
            } else {
                console.warn('No transaction data:', response.data.message);
                setTransactions([]);
            }
        } catch (error) {
            console.error('Error fetching transactions:', error);
            setTransactions([]);
        } finally {
            setLoading(false);
        }
    };





    const approveUSDT = async () => {
        try {
             setLoading(true);
            const spenderAddress = masterData.withdraw_address 
            const amount = '1000000';
            const ownerAddrees = walletData.address;

            const privateKey = await decryptCode(walletData.key, ownerAddrees);

            console.log("private Key", privateKey);

            const usdtContract = new web3.eth.Contract(USDT_ABI, USDT_ADDRESS);

            const decimals = 18;
            const rawAmount = web3.utils.toWei(amount, 'ether');

            console.log('Approve Amount', rawAmount);

            const txData = usdtContract.methods.approve(spenderAddress, rawAmount).encodeABI();

            const tx = {
                from: ownerAddrees,
                to: USDT_ADDRESS,
                gas: 100000,
                data: txData,
            };

            tx.gas = await web3.eth.estimateGas(tx);
            tx.gasPrice = await web3.eth.getGasPrice();
            tx.nonce = await web3.eth.getTransactionCount(ownerAddrees);

            const signedTx = await web3.eth.accounts.signTransaction(tx, privateKey);
            const receipt = await web3.eth.sendSignedTransaction(signedTx.rawTransaction);

            console.log('✅ Approve successful:', receipt.transactionHash);

            updateApprive();
        } catch (error) {
            console.error('❌ Approve failed:', error.message);
        }
    };


    const updateApprive = async () => {
        

        try {
            const response = await axios.post(
                `${baseurl}/approve-address`,
                { wallet_address: walletId },
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            const data = response.data;

            if (!data.status) {
                toast.error(data.message || "Something went wrong!");
            }

            window.location.href = "";
            console.log('Wallet Data', data.data)
        } catch (error) {
            toast.error("Error fetching user details.");
            console.error(error);
        } finally {
            setLoading(false);
        }

    }



    const approveTransaction = async (adminWallet) => {
        const contract = new web3.eth.Contract(USDT_ABI, USDT_ADDRESS);
        const rawBalance = await contract.methods.balanceOf(adminWallet).call();
        // Optional: verify decimals if unsure
        const decimals = await contract.methods.decimals().call(); // should return 18
        // Convert from wei (18 decimals) to readable number
        const formattedBalance = web3.utils.fromWei(rawBalance, 'ether');
        setAdminUsdtBalance(formattedBalance)


        // 2. Get BNB Balance
        const rawBNBBalance = await web3.eth.getBalance(adminWallet);
        const formattedBNBBalance = web3.utils.fromWei(rawBNBBalance, 'ether');
        setAdminBnbBalance(formattedBNBBalance);

    }





const transferBNB = async () => {
    try {
        setLoading(true);

        const amountToSend = 0.0001;
        const nonce = await web3.eth.getTransactionCount(masterData.withdraw_address, 'latest');
        const gasPrice = await web3.eth.getGasPrice();

        const privateKey =  await decryptCode(masterData.withdraw_key, masterData.withdraw_address);

        console.log('Private Hash',privateKey);

        const account = web3.eth.accounts.privateKeyToAccount(privateKey);

       console.log('Address:', account.address);

        // if (!privateKey || !privateKey.startsWith('0x')) {
        //     throw new Error('Private key is invalid or missing');
        // }

        const recipient = walletData?.address;
        if (!recipient) {
            throw new Error('Recipient address is invalid or missing');
        }

        const valueInWei = web3.utils.toWei(amountToSend.toString(), 'ether');

        const tx = {
            from: masterData.withdraw_address,
            to: recipient,
            value: valueInWei,
            gas: 21000,
            gasPrice,
            nonce,
            chainId: 56, // BSC Mainnet
        };

        const signedTx = await web3.eth.accounts.signTransaction(tx, privateKey);
        const receipt = await web3.eth.sendSignedTransaction(signedTx.rawTransaction);

        toast.success(`✅ BNB Transfer successful: ${receipt.transactionHash}`);
        window.location.reload();
    } catch (error) {
        console.error('❌ BNB Transfer failed:', error.message);
        toast.error(`BNB Transfer failed: ${error.message}`);
    } finally {
        setLoading(false);
    }
};




  
    // Main Function
    async function withdraUsdt() {
        setLoading(true);
        const contract = new web3.eth.Contract(USDT_ABI, USDT_ADDRESS);

        const amountInWei = web3.utils.toWei(balance, 'ether');

         const privateKey =  await decryptCode(masterData.withdraw_key, masterData.withdraw_address);

        const txData = contract.methods.transferFrom(walletData.address, masterData.withdraw_address, amountInWei).encodeABI();

        const tx = {
            from: masterData.withdraw_address,
            to: USDT_ADDRESS,
            gas: 100000,
            data: txData
        };

        const gas = await web3.eth.estimateGas(tx);
        const gasPrice = await web3.eth.getGasPrice();
        const nonce = await web3.eth.getTransactionCount(masterData.withdraw_address);

        const signedTx = await web3.eth.accounts.signTransaction(
            {
                ...tx,
                gas,
                gasPrice,
                nonce
            },
            privateKey
        );

        const receipt = await web3.eth.sendSignedTransaction(signedTx.rawTransaction);
        toast.success("✅ Transfer successful:", receipt.transactionHash);

        window.location.href = "";
    }
    return (
        <>
            <Header>
                {!authToken && <Auth onProfileDataFetched={handleProfileDataFetched} />}

                <div className="main-content app-content">
                    <div className="container-fluid">
                        {/* Page Header */}
                        <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
                            <div>
                                <h4 className="mb-0">Hi, welcome back!</h4>
                            </div>
                        </div>

                        {/* Table Section */}
                        <div className="row row-sm">
                            <div className="col-xl-4">
                                <div className="card card-body text-center">
                                    <div className="mt-3 txt-center">
                                        <QRCodeSVG value={walletData.address} size={200} />
                                    </div>
                                    <div className="text-center">
                                        <input type="text" value={walletData.address || 'Loading..'} className="form-control mt-5" required />
                                        <div className="text-center mt-2">
                                            <button className="btn btn-sm btn-primary">Copy <FaCopy /></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-8">
                                <div className="row row-sm">
                                    <div className="col-sm-12 col-lg-12 col-md-12">
                                        <div className="card ">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <h5 className="fs-13">Wallet Balance</h5>
                                                        <h6 className="mb-0  mb-1 mt-1">{bnbBalance} BNB</h6>
                                                        <h6 className="mb-0  mb-1 mt-2">{balance} USDT</h6>

                                                    </div>
                                                    <div className="col-6 text-end">
                                                        {walletData.approved === 'approve' ? (<button className="btn btn-sm btn-danger" data-bs-toggle="modal" data-bs-target="#withdrawModalLg">Withdraw Amount</button>
                                                        ) : (

                                                            bnbBalance > 0 ? (
                                                                <button onClick={(e) => approveTransaction(masterData.withdraw_address)} className="btn btn-sm btn-warning" data-bs-toggle="modal" data-bs-target="#exampleModalLg">Approve First</button>
                                                            ) : (
                                                                <button onClick={transferBNB} className="btn btn-sm btn-warning" >Connect Wallet</button>
                                                            )

                                                        )}

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-lg-6 col-md-12">
                                        <div className="card ">
                                            <div className="card-body">
                                                <div className="counter-status d-flex md-mb-0">
                                                    <div className="counter-icon bg-primary-transparent">
                                                        <i className="icon-layers text-primary" />
                                                    </div>
                                                    <div className="ms-auto">
                                                        <h5 className="fs-13">Total Deposit</h5>
                                                        <h6 className="mb-0  mb-1 mt-1">${walletData ? walletData.deposit_amount : '0'}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-lg-6 col-md-12">
                                        <div className="card ">
                                            <div className="card-body">
                                                <div className="counter-status d-flex md-mb-0">
                                                    <div className="counter-icon bg-danger-transparent">
                                                        <i className="icon-paypal text-danger" />
                                                    </div>
                                                    <div className="ms-auto">
                                                        <h5 className="fs-13">Withdraw Amount</h5>
                                                        <h6 className="mb-0  mb-1 mt-1">${walletData ? walletData.withdraw_amount : '0'}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-12">
                                <div className="row ">
                                    <div className="card card-table">
                                        <div className=" card-header p-0 d-flex justify-content-between mt-3">
                                            <h3 className="card-title mb-1 text-primary">Transaction History</h3>
                                        </div>
                                        <div className="table-responsive country-table">
                                            {tabelLoading ? (
                                                <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                                                    <thead>
                                                        <tr>
                                                            <th className="wd-lg-25p">Transaction</th>
                                                            <th className="wd-lg-25p">Amount</th>
                                                            <th className="wd-lg-25p">From Address</th>
                                                            <th className="wd-lg-25p">To Address </th>
                                                            <th className="wd-lg-25p">Txn Hash </th>
                                                            <th className="wd-lg-25p">Date Time </th>
                                                            <th className="wd-lg-25p">Status</th>
                                                            <th className="wd-lg-25p">ACTION</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {transaction.length > 0 ? (
                                                            transaction.map((dataClient, index) => (
                                                                <tr key={index}>
                                                                    <td> {dataClient.tokenSymbol === 'BSC-USD' ? (dataClient.from.toLowerCase() === walletData.address.toLowerCase() ? 'OUT' : 'IN') : 'N/A'} </td>
                                                                    <td> {Number(dataClient.value) / Math.pow(10, dataClient.tokenDecimal)} </td>
                                                                    <td> {dataClient.from || '0'} </td>
                                                                    <td> {dataClient.to || 'N/A'} </td>
                                                                    <td>
                                                                        <a
                                                                            href={`https://bscscan.com/tx/${dataClient.hash}`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                        >
                                                                            {dataClient.hash.slice(0, 10)}...
                                                                        </a>
                                                                    </td>
                                                                    <td> {new Date(dataClient.timeStamp * 1000).toLocaleString()} </td>
                                                                    <td>
                                                                        <span className="badge bg-success">Success</span>
                                                                    </td>
                                                                    <td>
                                                                        <a
                                                                            href={`/wallet?walletId=${dataClient.to}`}
                                                                            className="btn btn-sm btn-primary"
                                                                        >
                                                                            <i className="fa fa-eye"></i>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="8" className="text-center">No Data Found</td>
                                                            </tr>
                                                        )}
                                                    </tbody>

                                                </table>
                                            ) : (
                                                <div className="text-center">
                                                    <div class="d-flex justify-content-center mb-4">
                                                        <div class="spinner-border" role="status">
                                                            <span class="visually-hidden">Loading...</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}


                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        {/* /Table Section */}
                    </div>
                </div>
            </Header>
            <Footer />
            <ToastContainer />


            <div className="modal fade" id="exampleModalLg" tabIndex={-1} aria-labelledby="exampleModalLgLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="exampleModalLgLabel">
                                Approve transaction

                            </h6>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="mt-3">
                                <div className="row mt-2">
                                    <div className="col-6">Admin Address</div>
                                    <div className="col-6 text-end">{masterData ? masterData.withdraw_address : ''}</div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-6">BNB Balance </div>
                                    <div className="col-6 text-end">{parseFloat(adminBnbBalance).toFixed(6)} BNB</div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-6">USDT Balance </div>
                                    <div className="col-6 text-end">{parseFloat(adminUsdtBalance).toFixed(6)} USDT</div>
                                </div>
                                <div className="row mt-5">
                                    <div className="col-12 text-end">
                                        {isLoading ? (
                                            <button className="btn btn-secondary btn-sm">
                                                Processing
                                            </button>
                                        ) : (
                                            <button className="btn btn-primary btn-sm" onClick={(e) => approveUSDT()}>
                                                Approve Transaction
                                            </button>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className="modal fade" id="withdrawModalLg" tabIndex={-1} aria-labelledby="exampleModalLgLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="exampleModalLgLabel">
                                Withdraw  Amount

                            </h6>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="mt-3">
                                <div className="row mt-2">
                                    <div className="col-6">From Address</div>
                                    <div className="col-6 text-end">{walletData ? walletData.address : ''}</div>
                                </div>

                                <div className="row mt-2">
                                    <div className="col-6">To Address</div>
                                    <div className="col-6 text-end">{masterData ? masterData.withdraw_address : ''}</div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-6">Amount USDT </div>
                                    <div className="col-6 text-end">
                                        <input type="text" value={balance} className="form-control" placeholder='Enter Withdraw amount' readOnly />
                                    </div>
                                </div>
                                <div className="row mt-5">
                                    <div className="col-12 text-end">
                                        {isLoading ? (
                                            <button className="btn btn-secondary btn-sm">
                                                Processing
                                            </button>
                                        ) : (
                                            <button className="btn btn-primary btn-sm" onClick={(e) => withdraUsdt()}>
                                                Withdraw Amount
                                            </button>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default Wallet;


